import parcelShieldUserService from "../api/server/parcelShieldUserService";
export const PARCEL_SHIELD_USERS_NAMESPACE = "parcelShieldUsersModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/parcelShieldUserService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(parcelShieldUserService)
};

const state = {
  loading: true,
  users: [],
  roles: [],
  selectedUser: {},
  clients: []
};
const actions = {
  async checkUniqueUserName(context, userName) {
    var api = await services.api;
    return api.uniqueUserName(userName).then(response => {
      return response;
    });
  },
  selectUser(context, data) {
    return context.commit("SET_USER", data);
  },
  saveUser(context, data) {
    context.commit("SAVE_USER", data);
  },
  async loadUsers(context) {
    var api = await services.api;
    context.commit("SET_USER_LIST", []);
    context.state.loading = true;
    return api.loadParcelShieldUsers().then(response => {
      context.commit("SET_USER_LIST", response);
      context.state.loading = false;
    });
  },
  async loadClientList(context) {
    var api = await services.api;
    return api.loadClients().then(response => {
      context.commit("SET_CLIENT_LIST", response);
    });
  },
  async loadUserRoles(context) {
    var api = await services.api;
    context.commit("SET_ROLE_LIST", []);
    api.fetchRoles().then(response => {
      context.commit("SET_ROLE_LIST", response);
    });
  }
};

const mutations = {
  SET_USER(storeState, data) {
    if (data) {
      storeState.selectedUser = data;
      if (storeState.selectedUser.UserRoles) {
        /* istanbul ignore next */
        storeState.selectedUser.UserRoles = storeState.selectedUser.UserRoles.sort(
          function(a, b) {
            return a.Name.toLowerCase() > b.Name.toLowerCase()
              ? 1
              : b.Name.toLowerCase() > a.Name.toLowerCase()
              ? -1
              : 0;
          }
        );
      }
    } else state.selectUser = {};
  },
  async SAVE_USER(storeState, data) {
    var api = await services.api;
    return api.saveParcelShieldUser(data).then(res => {
      var index = -1;
      var updatedUser = data;
      if (res.length > 0) {
        updatedUser = res[0];
      }
      updatedUser.Password = null;
      updatedUser.SendEmail = null;
      // -- splice in the modified user
      for (var i = 0; i < storeState.users.length; i++) {
        if (storeState.users[i].Id === updatedUser.Id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        storeState.users.splice(index, 1, updatedUser);
      } else {
        storeState.users.push(updatedUser);
      }
      storeState.selectedUser = {};
    });
  },
  SET_USER_LIST(storeState, data) {
    storeState.users = data;
  },
  SET_ROLE_LIST(storeState, data) {
    storeState.roles = data.sort(function(a, b) {
      /* istanbul ignore next */
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
  },
  SET_CLIENT_LIST(storeState, data) {
    storeState.clients = data.sort(function(a, b) {
      /* istanbul ignore next */
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
  }
};

const getters = {
  loading: storeState => storeState.loading,
  users: storeState => storeState.users,
  roles: storeState => storeState.roles,
  selectedUser: storeState => storeState.selectedUser,
  clients: storeState => storeState.clients
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
